module.exports = __webpack_public_path__ + "img/回头.3f634651.gif";